import { ApolloClient } from '@apollo/client'
import { gql } from '@apollo/client/core'
import { IDimensions } from '@dxp-module/common'
import cache from './cache'

const typeDefs = gql`
  scalar Tradein
`

const generateApolloClient = (
  dimensions: IDimensions,
  headers?: Record<string, string>
) =>
  new ApolloClient({
    uri: String(import.meta.env.VITE_APP_GRAPHQL_SERVER_URL),
    cache,
    headers: {
      ...headers,
      'X-Brand': dimensions.brand,
      'X-Language': dimensions.language,
      'X-Region': dimensions.region,
      'X-Country': dimensions.country,
    },
    typeDefs,
  })

export default generateApolloClient
